import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12" }
const _hoisted_2 = { class: "col-span-12 col-start-1 md:col-span-8 md:col-start-3" }
const _hoisted_3 = { class: "max-w-3xl mx-auto text-center font-gotham-bold" }
const _hoisted_4 = { class: "mt-4 text-lg text-brand-secondary font-gotham-bold" }
const _hoisted_5 = { class: "mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8" }
const _hoisted_6 = { class: "flex flex-col items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-2xl h-20 pt-4 leading-6 font-gotham-bold text-brand-primary" }
const _hoisted_9 = { class: "mt-2 font-gotham-medium text-gray-700" }

import Title from './Title.vue';


type FeaturesData = {
  features: Array<{
    name: string,
    description: string,
    img?: string,
    imghover: string
  }>,
  header: {
    headline: string,
    tagline: string
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HispFeatures',
  props: {
    features: {},
    header: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Title, {
          title: _ctx.header.headline,
          centered: true
        }, null, 8, ["title"]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.header.tagline), 1)
      ]),
      _createElementVNode("dl", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
          return (_openBlock(), _createElementBlock("div", {
            key: feature.name,
            class: "relative items-center text-center"
          }, [
            _createElementVNode("dt", _hoisted_6, [
              _createElementVNode("img", {
                src: feature.img,
                class: "text-center items-center"
              }, null, 8, _hoisted_7),
              _createElementVNode("p", _hoisted_8, _toDisplayString(feature.name), 1)
            ]),
            _createElementVNode("dd", _hoisted_9, _toDisplayString(feature.description), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})